'use strict';

import React, { PropTypes } from 'react';
import BackColorMixin from '../mixins/BackColorMixin';
import ClassNameMixin from '../mixins/ClassNameMixin';
import ZineLink from '../atoms/ZineLink';
import UserLink from '../atoms/UserLink';
import SubmitStampControl from '../molecules/SubmitStampControl';
import FollowZineButton from '../molecules/FollowZineButton';
import FontTest from '../atoms/FontTest';
import PureRenderMixin from '../mixins/PureRenderMixin';
import createStoreMixin from '../mixins/createStoreMixin';
import UserStore from '../stores/UserStore';
import pluralize from '../utils/pluralize';
import formatCount from '../utils/formatCount';
import getZineThumbnail from '../utils/getZineThumbnail';
import getZineCover from '../utils/getZineCover';
import getThumbnailUrl from '../utils/getThumbnailUrl';
import isBestOf2014Special from '../utils/isBestOf2014Special';
import ZineStatus from '../constants/ZineStatus';
import Icon from '../atoms/Icon';

require('./ZineItem.less');

const ZineItem = React.createClass({
  mixins: [createStoreMixin(UserStore), BackColorMixin, ClassNameMixin, PureRenderMixin],

  className: 'ZineItem',

  propTypes: {
    zine: PropTypes.object.isRequired,
    stamp: PropTypes.object,
    showSubmit: PropTypes.bool.isRequired,
    showFollow: PropTypes.bool.isRequired,
    size: PropTypes.oneOf(['small', 'medium', 'large']).isRequired
  },

  getDefaultProps() {
    return {
      showSubmit: false,
      showFollow: true,
      size: 'medium'
    };
  },

  getStateFromStores(props) {
    const zine = props.zine;

    return {
      curator: UserStore.get(zine.curator),
      recentContributors: (zine.recentContributors || []).map(UserStore.get)
    };
  },

  getCSSModifiers() {
    return [
      this.props.size,
      this.getZineTextColor(),
      isBestOf2014Special(this.props.zine) && '2014special'
    ];
  },

  getZineBackColor() {
    return this.props.zine.backColor;
  },

  getZineTextColor() {
    return this.getTextColor(this.getZineBackColor());
  },

  getThumbnailUrl() {
    const thumbnail = getZineThumbnail(this.props.zine);
    const remSize = this.props.size === 'small' ? 5 : 7.5;
    const devicePixelRatio = (typeof window !== 'undefined') ? window.devicePixelRatio : 1;

    const size = remSize * 16 * Math.round(devicePixelRatio);

    return getThumbnailUrl(thumbnail, {
      mode: 'scale_crop',
      width: size,
      height: size
    });
  },

  getCoverStyle(zine) {
    const zineCover = getZineCover(zine);
    if (zineCover.isDefault) {
      return {
        backgroundSize: 'auto',
        backgroundImage: 'url(' + zineCover.url + ')'
      };
    }
    const devicePixelRatio = (typeof window !== 'undefined') ? window.devicePixelRatio : 1;

    const size = 30 * 16 * Math.round(devicePixelRatio);
    const thumbnailUrl = getThumbnailUrl(zineCover, {
      width: size,
      height: size
    });

    return {
      backgroundSize: 'cover',
      backgroundImage: 'url(' + thumbnailUrl + ')'
    };
  },

  render() {
    const zine = this.props.zine;
    const titleFontFamily = isBestOf2014Special(zine) ? 'playfair-display' : null;
    const isUnlisted = zine.status === ZineStatus.UNLISTED;

    return (
      <div className={this.getClassName()}
           style={{
            backgroundColor: '#' + this.getZineBackColor()
           }}>

        <ZineLink className='ZineItem-body'
                  zine={zine}
                  underline='never'
                  withEllipsis={false}>
          <div className='ZineItem-header'>
            {isUnlisted &&
              <span className='ZineItem-badge ZineItem-secret'
                    title='This Collection is only visible to those who have the direct link to it.'>
                <Icon name='eyeCrossed'
                      mode='fill'
                      size='xsmall'
                      margin='right' />
                Secret
              </span>
            }
            <div className='ZineItem-avatar'
                 style={{
                   backgroundColor: '#' + this.getZineBackColor(),
                   backgroundImage: 'url(' + this.getThumbnailUrl() + ')'
                 }} />

            <div className='ZineItem-coverImage'
                 style={this.getCoverStyle(zine)} />
          </div>

          <div className='ZineItem-info'>
            <FontTest family={titleFontFamily}
                      test={zine.title}>
              <h3 className='ZineItem-title'>
                {zine.title}
              </h3>
            </FontTest>

            <FontTest family='minion-pro-condensed'
                      test={zine.description}>
              <p className='ZineItem-description'>
                {zine.description}
              </p>
            </FontTest>
          </div>
        </ZineLink>

        {this.renderFooter()}
      </div>
    );
  },

  renderFooter() {
    if (isBestOf2014Special(this.props.zine)) {
      return null;
    }

    const { header, content } = this.renderFooterContent();

    if (!header && !content) {
      return null;
    }

    return (
      <div className='ZineItem-footer'>
        {header &&
          <div className='ZineItem-footerHeader'>
            {header}
          </div>
        }

        {content &&
          <div className='ZineItem-footerContent'>
            {content}
          </div>
        }
      </div>
    );
  },

  renderFooterContent() {
    const { showSubmit, showFollow, zine, stamp, size } = this.props;
    const canShowFollow = zine.status === ZineStatus.PUBLIC;
    const isSmall = size === 'small';

    if (showSubmit) {
      return {
        header: null,
        content: (
          <SubmitStampControl zine={zine}
                              stamp={stamp}
                              color={this.getZineTextColor()} />
        )
      };
    } else if (showFollow) {
      return {
        header: !isSmall && this.renderCurator(),
        content: canShowFollow && this.renderFollowButtonOrLabel()
      };
    } else {
      return {
        header: !isSmall && this.renderCurator(),
        content: null
      };
    }
  },

  renderCurator() {
    const { curator } = this.state;

    return (
      <div className='ZineItem-curator'>
        <span>Curated by </span>
        <UserLink user={curator}
                  className='ZineItem-curatorLink'
                  bold />
      </div>
    );
  },

  renderFollowButtonOrLabel() {
    const { zine } = this.props;
    const { curator } = this.state;
    const { subscriberCount } = zine;

    if (UserStore.isMe(curator)) {
      return (
        <span>
          {formatCount(subscriberCount)}
          {' '}
          {pluralize(subscriberCount, 'Follower', 'Followers')}
        </span>
      );
    }

    return (
      <FollowZineButton zine={zine} />
    );
  }
});

export default ZineItem;



/** WEBPACK FOOTER **
 ** ./organisms/ZineItem.jsx
 **/